function l(e) {
  let r = e == null ? void 0 : e.toLowerCase();
  return r = r.replace(/[^a-zA-Z\d-_!~*'()]+/g, "-"), r;
}
export {
  l as makeValidPath
};
